var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXamarin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3498DB",
    d: "M37.8 9c-3.4 0-6.6 1.9-8.3 4.8L3.2 59.2c-1.7 3-1.7 6.6 0 9.6l26.2 45.4c1.8 2.9 4.9 4.8 8.3 4.8h52.4c3.4 0 6.6-1.9 8.3-4.8l26.2-45.4c1.7-3 1.7-6.6 0-9.6L98.5 13.8C96.8 10.9 93.6 9 90.2 9H37.8zm.5 26.6h9.3c.4 0 .8.2 1 .6l15.3 27.3c.1.1.1.3.1.4 0-.2.1-.3.1-.4l15.3-27.3c.2-.4.6-.6 1-.6h9c.7.1 1.2.7 1.1 1.4 0 .1 0 .2-.1.4L75.6 64l15 26.7c.3.6 0 1.4-.6 1.6-.1.1-.3.1-.4.1h-9.1c-.4 0-.8-.2-1-.6L64.1 64.5c-.1-.1-.1-.3-.1-.4 0 .2-.1.3-.1.4L48.5 91.8c-.2.4-.6.6-1 .6h-9c-.7-.1-1.2-.7-1.1-1.3 0-.1.1-.3.1-.4l15-26.7-15-26.7c-.3-.6 0-1.3.6-1.6 0-.1.1-.1.2-.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXamarin);
export default __webpack_public_path__ + "static/media/Xamarin.847cd5d1fd0657a20f34f22dd53ec720.svg";
export { ForwardRef as ReactComponent };